<template>
  <v-snackbar
    v-model="isSnackbar"
    :color="color"
    :timeout="timeout"
    style="z-index: 9999;"
  >
    <div
      v-for="(item, index) in messages"
      :key="`message_${index}`"
    >
      {{ item }}
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="hideSnackbar"
      >
        閉じる
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

  import { mapState, mapActions } from 'vuex'

  /**
   * example
   * <snackbar />
   */
  export default {
    name: 'SnackbarComponent',
    data () {
      return {
        isSnackbar: false,
        messages: [],
      }
    },
    computed: {
      ...mapState('snackbar', {
        isShow: 'isShow',
        message: 'message',
        color: 'color',
        timeout: 'timeout'
      }),
    },
    watch: {
      isShow (newVal) {
        this.isSnackbar = newVal
      },
      message (newVal) {
        this.messages = (newVal === null) ? [] : newVal.split(',')
      },
      isSnackbar(newVal) {
        if (!newVal) this.hide()
      },
    },
    methods: {
      ...mapActions('snackbar', {
        hide: 'hide'
      }),
    hideSnackbar () {
        this.hide()
    }
  }
}

</script>

<style scoped lang="scss">
</style>
 